/** Pomocné funkce pro localStorage tracking nedávno prohlédnutých produktů. */

const STORAGE_KEY = 'tiskstrihu_recently_viewed';
const MAX_ITEMS = 12;

export function readRecentlyViewed(): number[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((x) => typeof x === 'number') : [];
  } catch { return []; }
}

export function pushRecentlyViewed(productId: number): void {
  try {
    const list = readRecentlyViewed().filter((id) => id !== productId);
    list.unshift(productId);
    const trimmed = list.slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
  } catch {}
}

export function clearRecentlyViewed(): void {
  try { localStorage.removeItem(STORAGE_KEY); } catch {}
}
